import React, {useEffect} from 'react';
import { useQuery } from "react-query";

import { getQueryData, getVendorListURL, withCredentials } from "../../services";
import AIToolsSection from "./components/aIToolsSection/AIToolsSection";

export const AiTools = () => {
    const { data: vendorsData } = useQuery("vendorListData", async () =>
        getQueryData(getVendorListURL, withCredentials())
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return ( <AIToolsSection data={vendorsData?.data} />)
};




